import React from 'react';
import { PasswordInput } from '@ui';

type MatchConfirmationProps = {
    onBack: () => void;
    onHelp?: () => void;
};

export function MatchConfirmation({ onBack, onHelp }: MatchConfirmationProps) {
    return (
        <div className="min-h-screen bg-slate-100 px-4 py-12">
            <div className="mx-auto w-full max-w-sm overflow-hidden rounded-[32px] bg-white shadow-2xl shadow-slate-900/10">
                <header className="flex items-center justify-between px-5 pt-5">
                    <button
                        type="button"
                        onClick={onBack}
                        className="flex h-9 w-9 items-center justify-center rounded-full border border-slate-200 bg-white text-lg text-slate-500"
                        aria-label="Go back"
                    >
                        ←
                    </button>
                    <div className="flex items-center gap-3">
                        <span className="flex h-9 w-9 items-center justify-center rounded-full bg-slate-900 text-xs font-semibold uppercase text-white">
                            GC
                        </span>
                        <span className="text-base font-semibold text-slate-900">GuidesCollective</span>
                    </div>
                    <button
                        type="button"
                        onClick={onHelp}
                        className="flex h-9 w-9 items-center justify-center rounded-full border border-slate-200 bg-white text-sm font-semibold text-slate-500"
                        aria-label="Help"
                    >
                        ?
                    </button>
                </header>

                <main className="px-6 pb-12">
                    <section className="mt-10 flex flex-col items-center rounded-[26px] border border-slate-200 bg-slate-50/90 p-8 text-center shadow-[0_18px_38px_-24px_rgba(15,23,42,0.28)]">
                        <div className="flex h-20 w-20 items-center justify-center rounded-full bg-emerald-400 text-3xl text-white" aria-hidden>
                            ✓
                        </div>
                        <h2 className="mt-6 text-[22px] font-semibold text-slate-900">Your consultation is booked!</h2>
                        <p className="mt-3 text-sm leading-6 text-slate-600">
                            Please complete your account and we’ll send you a confirmation email.
                        </p>

                        <label className="mt-8 w-full text-left text-sm font-medium text-slate-700">
                            Enter a password
                            <PasswordInput
                                placeholder="Enter a password"
                                className="mt-2 w-full rounded-[14px] border border-slate-200 px-4 py-3 text-base text-slate-800 focus:border-slate-400 focus:outline-none"
                            />
                        </label>

                        <button
                            type="button"
                            className="mt-6 inline-flex w-full items-center justify-center rounded-[16px] bg-slate-900 py-3 text-sm font-semibold text-white"
                        >
                            Create my Account
                        </button>

                        <div className="mt-4 flex w-full items-center gap-3 text-xs font-medium uppercase tracking-[0.3em] text-slate-400">
                            <span className="h-px flex-1 bg-slate-200" />
                            or
                            <span className="h-px flex-1 bg-slate-200" />
                        </div>

                        <div className="mt-4 grid w-full grid-cols-2 gap-3">
                            <button
                                type="button"
                                className="rounded-[16px] border border-slate-200 bg-white py-3 text-sm font-semibold text-slate-700 shadow-sm"
                            >
                                Google
                            </button>
                            <button
                                type="button"
                                className="rounded-[16px] border border-slate-200 bg-white py-3 text-sm font-semibold text-slate-700 shadow-sm"
                            >
                                Apple
                            </button>
                        </div>

                        <p className="mt-6 text-xs leading-5 text-slate-400">
                            Your information is secure and will never be shared with third parties.
                        </p>
                    </section>
                </main>
            </div>
        </div>
    );
}
